import { get, update } from "lodash";
import { baseApi } from "..";
import { checkIsAdmin } from "../../../helpers/helpers";

// Define a service using a base URL and expected endpoints
export const prodOrderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    getTrimType: builder.query({
      query: () => `trim-type`,
      transformResponse: (response) => response.data,
    }),

  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetTrimTypeQuery,
} = prodOrderApi;